module.exports = __webpack_public_path__ + "img/27.086e8a4a.jpg";